
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/feature/Header';
import BottomNavigation from '../../components/feature/BottomNavigation';
import ProductCard from '../../components/feature/ProductCard';
import { featuredProducts, categories } from '../../mocks/products';

export default function CategoriesPage() {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const [cartItems, setCartItems] = useState<any[]>(() => {
    const saved = localStorage.getItem('cartItems');
    return saved ? JSON.parse(saved) : [];
  });
  const [showAddedMessage, setShowAddedMessage] = useState(false);
  const [addedProduct, setAddedProduct] = useState<any>(null);

  const handleAddToCart = (product: any) => {
    const existingItem = cartItems.find(item => item.id === product.id);
    
    let updatedCart;
    if (existingItem) {
      updatedCart = cartItems.map(item => 
        item.id === product.id 
          ? { ...item, quantity: item.quantity + 1 }
          : item
      );
    } else {
      updatedCart = [...cartItems, { ...product, quantity: 1 }];
    }
    
    setCartItems(updatedCart);
    localStorage.setItem('cartItems', JSON.stringify(updatedCart));

    setAddedProduct(product);
    setShowAddedMessage(true);
    
    setTimeout(() => {
      setShowAddedMessage(false);
      setAddedProduct(null);
    }, 3000);
  };

  const handleProductClick = (productId: number) => {
    navigate(`/product/${productId}`);
  };

  const handleCategoryClick = (categoryName: string) => {
    setSelectedCategory(categoryName);
  };

  const handleBackToCategories = () => {
    setSelectedCategory(null);
  };

  // تصفية المنتجات حسب الفئة المختارة
  const filteredProducts = selectedCategory 
    ? featuredProducts.filter(product => {
        switch(selectedCategory) {
          case 'القهوة الفاخرة':
            return product.category === 'coffee';
          case 'أدوات التحضير':
            return product.category === 'tools';
          case 'آلات القهوة':
            return product.category === 'machines';
          case 'الإكسسوارات':
            return product.category === 'accessories';
          default:
            return true;
        }
      })
    : [];

  const totalCartItems = cartItems.reduce((total, item) => total + item.quantity, 0);

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Header cartItemsCount={totalCartItems} />
      
      {/* رسالة تأكيد الإضافة */}
      {showAddedMessage && addedProduct && (
        <div className="fixed top-20 left-4 right-4 z-50 bg-green-500 text-white p-4 rounded-lg shadow-lg transform transition-all duration-300">
          <div className="flex items-center justify-between" dir="rtl">
            <div className="flex items-center">
              <i className="ri-check-line text-xl ml-2"></i>
              <span className="font-medium">تم إضافة "{addedProduct.name}" إلى السلة</span>
            </div>
            <button 
              onClick={() => setShowAddedMessage(false)}
              className="text-white/80 hover:text-white"
            >
              <i className="ri-close-line text-xl"></i>
            </button>
          </div>
        </div>
      )}
      
      <main className="pt-20 pb-20 px-4">
        {/* عرض الأقسام فقط */}
        {!selectedCategory && (
          <>
            {/* Page Title */}
            <div className="mb-6" dir="rtl">
              <h1 className="text-2xl font-bold text-[#333333] mb-2">الأقسام</h1>
              <p className="text-[#777777] text-sm">اختر القسم المناسب لتصفح المنتجات</p>
            </div>

            {/* Categories Grid */}
            <div className="grid grid-cols-2 gap-4">
              {categories.map((category) => (
                <div
                  key={category.id}
                  onClick={() => handleCategoryClick(category.name)}
                  className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-200 cursor-pointer hover:scale-105"
                >
                  <div className="flex flex-col items-center text-center">
                    <div className="w-20 h-20 mb-4 overflow-hidden rounded-full">
                      <img
                        src={category.icon}
                        alt={category.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <h3 className="font-bold text-[#333333] text-base mb-2">
                      {category.name}
                    </h3>
                    <span className="text-sm text-[#777777] mb-3">
                      {category.count} منتج
                    </span>
                    <div className="w-8 h-8 bg-[#D4AF37]/10 rounded-full flex items-center justify-center">
                      <i className="ri-arrow-left-line text-[#D4AF37] text-lg"></i>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* معلومات إضافية */}
            <div className="mt-8 bg-white rounded-xl p-6 shadow-md">
              <div className="text-center" dir="rtl">
                <div className="w-16 h-16 bg-[#D4AF37]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-store-line text-[#D4AF37] text-2xl"></i>
                </div>
                <h3 className="font-bold text-[#333333] text-lg mb-2">
                  متجر القهوة الفاخرة
                </h3>
                <p className="text-[#777777] text-sm leading-relaxed">
                  اكتشف مجموعتنا المتنوعة من القهوة الفاخرة والأدوات المتخصصة لتحضير أفضل كوب قهوة
                </p>
              </div>
            </div>
          </>
        )}

        {/* عرض منتجات القسم المختار */}
        {selectedCategory && (
          <>
            {/* Header with back button */}
            <div className="flex items-center justify-between mb-6" dir="rtl">
              <div>
                <h1 className="text-2xl font-bold text-[#333333] mb-1">
                  {selectedCategory}
                </h1>
                <p className="text-[#777777] text-sm">
                  {filteredProducts.length} منتج متاح
                </p>
              </div>
              <button 
                onClick={handleBackToCategories}
                className="w-10 h-10 bg-[#D4AF37]/10 rounded-full flex items-center justify-center"
              >
                <i className="ri-arrow-right-line text-[#D4AF37] text-xl"></i>
              </button>
            </div>

            {/* Breadcrumb */}
            <div className="flex items-center mb-6 text-sm" dir="rtl">
              <button 
                onClick={handleBackToCategories}
                className="text-[#D4AF37] hover:underline"
              >
                الأقسام
              </button>
              <i className="ri-arrow-left-line text-[#777777] mx-2"></i>
              <span className="text-[#333333] font-medium">{selectedCategory}</span>
            </div>
            
            {/* Products Grid */}
            {filteredProducts.length > 0 ? (
              <div className="grid grid-cols-2 gap-4">
                {filteredProducts.map((product) => (
                  <ProductCard
                    key={product.id}
                    product={product}
                    onAddToCart={handleAddToCart}
                    onClick={() => handleProductClick(product.id)}
                  />
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <div className="w-20 h-20 bg-[#777777]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-search-line text-[#777777] text-3xl"></i>
                </div>
                <h3 className="text-lg font-semibold text-[#333333] mb-2">
                  لا توجد منتجات
                </h3>
                <p className="text-[#777777] mb-6">
                  لا توجد منتجات في هذا القسم حالياً
                </p>
                <button 
                  onClick={handleBackToCategories}
                  className="bg-[#D4AF37] text-white px-6 py-3 rounded-lg font-medium hover:bg-[#B8941F] transition-colors duration-200"
                >
                  العودة للأقسام
                </button>
              </div>
            )}
          </>
        )}
      </main>

      <BottomNavigation />
    </div>
  );
}
